<template>
  <div>
  <v-app>
  <v-container fluid fill-height>
   <v-content>
    <v-layout justify-center>
      <v-flex xs6>
        <v-container class="text-xs-center">
         <v-flex xs4 mb-3>
            <v-img src="/static/img/logo_white_bg.png" contain>
            </v-img>
         </v-flex>
          <v-card class="elevation-12">
            <v-toolbar dark color="primary">
                  <v-toolbar-title>Password Reset</v-toolbar-title>
            </v-toolbar>
             <v-card-text>

                <div v-if="emailValid">
                  <v-alert :value="true" color="warning"> {{ emailValid }} </v-alert>
                </div>

                <div v-if="emailSent">
                  <v-alert :value="true" color="success"> {{ emailSent }} </v-alert>
                </div>
                
                    <v-form ref="form" v-model="valid" lazy-validation>
                      <v-text-field 
                        name="email" 
                        label="Enter Email Address" 
                        v-model="user.username"
                        :rules="emailRules"
                        required>
                      </v-text-field>
                    </v-form>
            </v-card-text>

           <v-card-actions>
              <router-link class="pageLink" to="/login"> <v-btn> Go Back </v-btn> </router-link>
              <v-spacer> </v-spacer>
              <v-btn @click="passwordReset" color="primary">Submit</v-btn>
           </v-card-actions>
                 
          </v-card>
        </v-container>
      </v-flex>
    </v-layout>
   </v-content>
  </v-container>
  </v-app>
 </div>
</template>
<script>
import axios from 'axios'
import config from '../config'
import store from '../store'

export default {
  name: 'PasswordResetRequest',
  data: function() {
    return {
      section: 'PasswordResetRequest',
      emailValid: '',
      emailSent: '',
      response: '',
      user: {
        'username': ''
      },
      valid: false,
      emailRules: [
        v => !!v || 'Email is required'
      ]
    }
  },
  methods: {
    passwordReset() {
      var url = config.serverURI + '/user/passwordresetrequest'
      var token = store.state.token
      this.emailValid = ''
      this.emailSent = ''

      console.log(this.user)
      axios
        .post(url, this.user, {
          headers: {
            'Authorization': token,
            'Content-Type': 'application/json'
          }
        })
        .then(response => {
          var data = response.data

          if (data.error === true) {
            this.emailValid = data.message
            console.log(this.tokenInvalidMessage)
          }
          this.emailSent = data.message
          console.log(data)
        })
        .catch(error => {
          console.log(error)
          this.emailValid = 'Server appears to be offline'
        })
    }
  }
}

</script>
<style>

</style>



// WEBPACK FOOTER //
// passwordresetrequest.vue?6a16554b